import { ChiptaElement, html } from 'chipta-libs/main.js';

class StyledInput extends ChiptaElement {

  static get properties() {
    return {
      validate: {type: Boolean}
    };
  }

  render() {

    /*
     * NOTE: The <slot> element needs a container other than a custom element.
     * Otherwise it won't render in webcomponent polyfilled browsers (Edge, IE).
     */

    return html`

      <span id="container" ?validate=${this.validate}>
        <slot></slot>
      </span>

      <style>

        :host {
          display: inline-block;
        }

        #container ::slotted(input[type=text]),
        #container ::slotted(input[type=email]),
        #container ::slotted(input[type=password]),
        #container ::slotted(input[type=date]),
        #container ::slotted(input[type=number]),
        #container ::slotted(input[type=tel]),
        #container ::slotted(input[type=url]),
        #container ::slotted(select) {
          box-sizing: border-box;
          height: 30px;
          border: 1px #BBB solid;
          border-radius: 3px;
          padding: 3px 15px;
          box-shadow: none;
          outline: none;
          background: #FFF;
          color: ${_themeData.text_color};
        }

        #container ::slotted(input[type=text]:focus),
        #container ::slotted(input[type=email]:focus),
        #container ::slotted(input[type=password]:focus),
        #container ::slotted(input[type=date]:focus),
        #container ::slotted(input[type=number]:focus),
        #container ::slotted(input[type=tel]:focus),
        #container ::slotted(input[type=url]:focus),
        #container ::slotted(select:focus) {
					box-shadow: inset 0 0 10px #DDD;
        }

        #container ::slotted(input[type=text][disabled]),
        #container ::slotted(input[type=email][disabled]),
        #container ::slotted(input[type=password][disabled]),
        #container ::slotted(input[type=date][disabled]),
        #container ::slotted(input[type=number][disabled]),
        #container ::slotted(input[type=tel][disabled]),
        #container ::slotted(input[type=url][disabled]),
        #container ::slotted(select[disabled]) {
          color: ${_themeData.light_text_color};
          background-color: #EFEFEF;
          cursor: not-allowed;
        }

        #container ::slotted(select) {
          padding-right: 30px;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15"><path fill="rgb(100, 100, 100)" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>');
          background-position: right 11px center;
          background-repeat: no-repeat;
        }

        #container ::slotted(select:-moz-focusring) {
          /* This removes the dotted outline in Firefox, see:
           * http://notes.jerzygangi.com/how-to-remove-the-dotted-border-from-around-select-tags-in-firefox/
           */
          color: transparent;
          text-shadow: 0 0 0 #000;
        }

        #container[validate] ::slotted(input[type=text]:invalid),
        #container[validate] ::slotted(input[type=email]:invalid),
        #container[validate] ::slotted(input[type=password]:invalid),
        #container[validate] ::slotted(input[type=date]:invalid),
        #container[validate] ::slotted(input[type=number]:invalid),
        #container[validate] ::slotted(input[type=tel]:invalid),
        #container[validate] ::slotted(input[type=url]:invalid),
        #container[validate] ::slotted(select:invalid) {
          border-color: red;
          box-shadow: 0 0 3px red;
        }

        #container[validate] ::slotted(input[type=radio]:invalid)::after {
          content: '';
          box-sizing: border-box;
          display: block;
          width: 100%;
          height: 100%;
          background: transparent;
          border: 1px solid red;
          box-shadow: 0 0 3px red;
          border-radius: 100%;
        }

        @media screen and (max-width: 500px) {

          #container ::slotted(input[type=text]),
          #container ::slotted(input[type=email]),
          #container ::slotted(input[type=password]),
          #container ::slotted(input[type=date]),
          #container ::slotted(input[type=number]),
          #container ::slotted(input[type=tel]),
          #container ::slotted(input[type=url]),
          #container ::slotted(select) {
            height: 40px;
          }

        }

      </style>

    `;

  }

}

customElements.define('styled-input', StyledInput);
